var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skelton-loader"},[(_vm.isLoading)?_c('v-sheet',{staticClass:"pa-3"},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":_vm.type,"loading":_vm.isLoading}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }